import Step1 from "./cancel-1.png";
import Step2 from "./cancel-2.png";

const cancelImg = [
  { id: "Step1", imageName: Step1, imageDesc: "Cancel Step 1" },
  { id: "Step2", imageName: Step2, imageDesc: "Cancel Step 2" },
];

export default cancelImg as HelpImage[];
